import { useState, useContext, useEffect } from 'react'
import { AuthContext } from '../../contexts/auth-context'
import { toast } from 'sonner'
import { sendBusinessOtp, verifyBusinessOtp, verifyOtp } from '../../services'

const OtpVerification = ({ isMessageVerify = false, onClose, handleSendMessage }) => {
  const { handleVerifyOtp, otp, setOtp, handleSignInUser, userSignInFormData, auth } =
    useContext(AuthContext)

  // Initialize otp with 4 digits
  useEffect(() => {
    if (!otp || otp.length !== 4) {
      setOtp(Array(4).fill(''))
    }
  }, [])

  const handleMessageVerifyOtp = async () => {
    const combinedOtp = otp.join('')
    const messageVerifyPayload = {
      otp: combinedOtp,
    }

    // Call the verifyOtp function from context

    try {
      const { data } = await verifyBusinessOtp(messageVerifyPayload)

      if (data.status === 200) {
        toast.success('OTP verified successfully for message sending')

        // set the otp empty and close the otp modal
        setOtp(Array(4).fill(''))
        // you can add any additional logic here, like closing a modal
        // close the modal if onClose prop is provided
        if (onClose) {
          onClose()
        }

        // then send the message after successful otp verification
        setTimeout(() => {
          handleSendMessage()
        }, 1000)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }

  // ------ resend business otp ------
  const handleSendBusinessOtp = async () => {
    try {
      const { data } = await sendBusinessOtp()

      if (data.status === 200) {
        toast.success(data?.message)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }

  const handleChange = (index, value) => {
    // Allow digits only
    if (!/^\d*$/.test(value)) return

    const newOtp = [...otp]
    // Take the last character entered to handle replacement
    // e.g., if value is "12", take "2"
    const char = value.slice(-1)

    newOtp[index] = char
    setOtp(newOtp)

    // If a digit was entered, move to next input
    if (char && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus()
    }
  }

  // Add this function to handle Backspace key
  const handleKeyDown = (index, e) => {
    // If Backspace is pressed on an empty field, move focus to the previous input
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus()
    }
  }

  return (
    <div className="flex items-center justify-center bg-white px-4">
      <div className="max-w-md w-full text-center">
        <h2 className="text-3xl font-bold mb-2">OTP Verification</h2>
        <p className="text-gray-500 mb-6">
          A verification code has been sent to xxxxxx
          {isMessageVerify
            ? auth.authenticate && auth.user?.mobile?.slice(-4)
            : userSignInFormData?.mobile?.slice(-4)}
        </p>

        {/* OTP Input Boxes */}
        <div className="flex justify-center gap-4 mb-4">
          {otp &&
            otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                placeholder="-"
                // maxLength={1}
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onFocus={(e) => e.target.select()}
                className="w-16 h-16 text-center border border-purple-300 rounded-md text-xl focus:outline-none focus:border-heading-primary"
              />
            ))}
        </div>

        {/* Resend link only */}
        <p className="text-sm text-gray-600 mb-6">
          Didn't receive code?{' '}
          <button
            onClick={isMessageVerify ? handleSendBusinessOtp : handleSignInUser}
            className="text-heading-primary font-semibold hover:underline p-0 m-0"
            style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
          >
            Resend
          </button>
        </p>

        {/* Verify Button */}
        <button
          onClick={isMessageVerify ? handleMessageVerifyOtp : handleVerifyOtp}
          className="w-full bg-heading-primary text-white py-3 rounded-md text-lg font-semibold cursor-pointer"
        >
          Verify
        </button>
      </div>
    </div>
  )
}

export default OtpVerification
